export default "__VITE_ASSET__9CgM9r85__"